import { Injectable } from "@angular/core";
import {  Http, Response, Headers, RequestOptions} from "@angular/http";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs/Observable";

import {IBlog, IOffer, IArticle, IDriverClubNews} from "./blog";
import { AppCommonService } from "../appcommon.service";
import { AuthService } from "../auth.service";
import { GlobalService } from "../global.service";
import { Router } from "@angular/router";
import { ApiEndPoints } from "../api.endpoints";
import { forEach } from "@angular/router/src/utils/collection";
import { BlogType } from "../genericpages/blogtypes";

@Injectable()
export class BlogService extends GlobalService {

    constructor(
        private http: Http,
        private cookieService: CookieService,
        private appCommonService: AppCommonService,
        private authService: AuthService,
        private router: Router
    ) {
        super(http, router);
        this.authServiceRef = this.authService;
    }

    getDriversClubNewsList(): Observable<IDriverClubNews[]> {      
      let options = new RequestOptions();
      const url = ApiEndPoints.BaseURL + ApiEndPoints.DriversClubNewsAPIUrl;
      return this.http.get(url, options)
        .map(data => <IDriverClubNews[]>data.json())
        .catch(this.handleError);
    }



    getBlogsList(cat?: string): Observable<IBlog[]> {
      if (!cat) {
        cat = BlogType.home;
      }
      let options = new RequestOptions();
      const url = ApiEndPoints.BaseURL + ApiEndPoints.BlogAPIUrl + cat;
      return this.http.get(url, options)
          .map(data => <IBlog[]>data.json())
          .catch(this.handleError);
    }

    getOffersList(cat?: string): Observable<IOffer[]> {
      if (!cat) {
        cat = null;
      }
      let options = new RequestOptions();
      const url = ApiEndPoints.BaseURL + ApiEndPoints.OffersAPIUrl + cat;
      return this.http.get(url, options)
        .map(data => <IOffer[]>data.json())
        .catch(this.handleError);
    }

    getDrawingArticlesList(): Observable<IArticle[]> {
      let options = new RequestOptions();
      const url = ApiEndPoints.BaseURL + ApiEndPoints.DrivingArticlesAPIUrl;
      return this.http.get(url, options)
        .map(data => <IArticle[]>data.json())
        .catch(this.handleError);
    }

}



// WEBPACK FOOTER //
// ./src/app/blogs/blog.service.ts